
import { useMemo, useRef, useState } from 'react'
import { VIDEO_FILE_PATH } from '../../constants/pathConstants'
import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import './style.scss'
import { EDITING_OPTIONS, EDITING_STATE } from '../../types/types'

function DashboardToolEditArea() {
	const showWatchVideos: boolean = useAppSelector(state => state.chat.showWatchVideos)
	const [videoSrc, setVideoSrc] = useState<string | undefined>(undefined)
	const [currentState, setCurrentState] = useState<EDITING_STATE>(EDITING_STATE.IDLE)
	const [videoState, setVideoState] = useState<'paused' | 'playing'>('paused')

	const videoWrapperRef = useRef<HTMLDivElement>(null)
	const videoRef = useRef<HTMLVideoElement>(null)
	const [videoWrapperWidth, setVideoWrapperWidth] = useState<number>(0)
	const [videoWrapperHeight, setVideoWrapperHeight] = useState<number>(0)
	const VIDEO_SPACE_HEIGHT_RATIO: number = 0.75 // height ratio of the video wrapper relative to its width, note video will scale to fit the given area and used to determine overlay element positions

	const mediaStream = useRef<MediaStream | undefined>(undefined)
	const mediaRecorder = useRef<MediaRecorder | undefined>(undefined)
	const mediaChunks = useRef<Blob[]>([])
	const [mediaUrl, setMediaUrl] = useState<string>('')

	// ======================================== BUTTON CLICK EVENTS
	const onClickEditButton = () => {
		// if {currentState == EDITING_STATE.IDLE}
		setCurrentState(EDITING_STATE.DRAWING)
	}
	// const onClickLineButton = () => {
	// 	setCurrentState(EDITING_STATE.DRAWING_LINE)
	// }
	// const onClickShapeButton = () => {
	// 	setCurrentState(EDITING_STATE.DRAWING_SHAPE)
	// }

	const onVideoPlay = () => {
		setVideoState('playing')
	}
	const onVideoPause = () => {
		setVideoState('paused')
	}

	// Returns the current time in video in seconds
	const getVideoCurrentTime = (): number => {
		if (videoRef.current) {
			return videoRef.current.currentTime
		}
		return 0
	}

	const startRecording = async () => {
		try {
			const audioStream:MediaStream = await navigator.mediaDevices.getUserMedia({
				audio: true
			})
			mediaStream.current = audioStream
			mediaRecorder.current = new MediaRecorder(audioStream)
			mediaRecorder.current.ondataavailable = (evt) => {
				if (evt.data.size > 0) {
					mediaChunks.current.push(evt.data)
				}
			}
			mediaRecorder.current.onstop = () => {
				const recordedBlob: Blob = new Blob(
					mediaChunks.current, {type: 'audio/webm'}
				)
				const url: string = URL.createObjectURL(recordedBlob)
				setMediaUrl(url)
				mediaChunks.current = []
			}
			mediaRecorder.current.start()
		} catch (err) {
			console.log('Error accessing microphone')
		}
	}
	const stopRecording = () => {
		if (mediaRecorder.current && mediaRecorder.current.state === 'recording') {
			mediaRecorder.current.stop()
		}
		if (mediaStream.current) {
			mediaStream.current.getTracks().forEach((track: MediaStreamTrack) => {
				track.stop()
			})
		}
	}

	return (
		<div className='dashboard-tool-content-area-wrap'>
			<div className='dashboard-tool-video-area-wrap'>
				<div className='dashboard-tool-button-wrap'>
					<button 
						className='dashboard-tool-button'
						disabled={videoState == 'playing'}
						style={useMemo(
							() => ({
								background: currentState == EDITING_STATE.DRAWING ? '#444' : 'initial'
							}),
							[currentState]
						)}
						onClick={() => {
							onClickEditButton()
						}}
					>
						<img
							className='dashboard-tool-button-img'
							src='/imgs/icons/tool/icon-tool-edit.svg'
							alt='Edit button'
						/>
					</button>
					<button 
						className='dashboard-tool-button'
						disabled={videoState == 'playing'}
					>
						<img
							className='dashboard-tool-button-img'
							src='/imgs/icons/tool/icon-tool-line.svg'
							alt='Line button'
						/>
					</button>
					<button 
						className='dashboard-tool-button'
						disabled={videoState == 'playing'}
					>
						<img
							className='dashboard-tool-button-img'
							src='/imgs/icons/tool/icon-tool-shape.svg'
							alt='Shape button'
						/>
					</button>
				</div>
				<div 
					className='dashboard-tool-video-wrap'
					ref={videoWrapperRef}
				>
					{showWatchVideos && videoSrc &&
						<video
							id="example_video_1"
							ref={videoRef}
							className="video-js vjs-default-skin"
							width="600"
							height="264"
							// src={`${VIDEO_FILE_PATH}${userStateData.videoFileName}`}
							src={videoSrc}
							typeof='video/mp4'
							onPlay={() => {
								onVideoPlay()
							}}
							onPause={() => {
								onVideoPause()
							}}
							controls
						/>
					}
				</div>
				<div 
					className='dashboard-tool-record-wrap'
				></div>
			</div>
		</div>
	)
}

export default DashboardToolEditArea
